import * as React from "react";
import clsx from "clsx";
import { Button } from "../button/button.mjs";
import { Grid } from "../grid/grid/grid.mjs";
import { GridColumn } from "../grid/grid-column/grid-column.mjs";
import { Heading } from "../typography/heading/heading.mjs";
const PageHeading = (props) => {
  const { backButton, hideButton, ...rest } = props;
  const renderButton = (isHidden = false) => {
    var _a;
    const buttonProps = {
      size: "small",
      responsive: [{ breakPoint: "sm", props: { size: "default" } }],
      icon: "#arrow-left",
      variant: "secondary",
      ...backButton
    };
    const hiddenButtonProps = {
      ...buttonProps,
      id: void 0,
      attributes: {
        tabIndex: -1,
        "aria-hidden": true
      }
    };
    return /* @__PURE__ */ React.createElement(
      GridColumn,
      {
        width: ["min"],
        className: clsx(
          "page-heading__button",
          {
            "heading__button--hidden": isHidden
          },
          /* istanbul ignore next */
          Array.isArray(hideButton) ? hideButton.map((i) => "hidden-".concat(i)) : [],
          (_a = props.backButton) == null ? void 0 : _a.className
        ),
        align: ["middle-xs"]
      },
      isHidden ? /* @__PURE__ */ React.createElement(Button, { ...hiddenButtonProps }) : /* @__PURE__ */ React.createElement(Button, { ...buttonProps })
    );
  };
  const renderHeading = () => {
    const heading = /* @__PURE__ */ React.createElement(Heading, { className: "h3 text-center text-left-sm", ...rest });
    if (props.textEdit) {
      const { buttonProps, buttonText, onClick } = props.textEdit;
      return /* @__PURE__ */ React.createElement(Grid, { noWrap: true, align: ["middle-xs"], gutter: "small" }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["minmax"] }, heading), /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement(Button, { type: "text-color", link: true, icon: "#edit", iconSize: "xs", ...buttonProps, text: buttonText, onClick })));
    }
    return heading;
  };
  const renderSubContent = (props2) => {
    return /* @__PURE__ */ React.createElement(GridColumn, { width: ["max"], align: ["middle-xs"] }, /* @__PURE__ */ React.createElement("p", { className: "text-center text-left-sm ".concat(props2.className) }, props2.content));
  };
  return /* @__PURE__ */ React.createElement(Grid, { noWrap: true, verticalGutter: "none" }, renderButton(), /* @__PURE__ */ React.createElement(GridColumn, { width: ["max"], align: ["middle-xs"] }, renderHeading(), props.subContent && renderSubContent(props.subContent)), renderButton(true));
};
export {
  PageHeading
};
